// import { Box, Card, MenuItem, Select, Typography } from "@mui/material";
// import { Button } from "common/components";
// import { ReadMoreOutlined } from "@mui/icons-material";
// import { useNavigate } from "react-router-dom";
// import { useState } from "react";

// const NewDocumentUpload = () => {
//   const navigate = useNavigate();

//   return (
//     <div>
//       <Button
//         variant="text"
//         onClick={() => navigate(-1)}
//         style={{ marginBottom: "20px" }}
//       >
//         &larr; Back
//       </Button>
//       <h1 style={{ textAlign: "center" }}>Upload New Document</h1>
//       <Card
//         variant="outlined"
//         sx={{
//           backgroundColor: "transparent",
//           color: "#ffffff",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           flexDirection: "column",
//           padding: 4,
//           border: "1px solid #ffffff"
//         }}
//       >
//         <Button
//           onClick={() => navigate(`/bulk-upload/NewDocument`)}
//           variant="primary-alt"
//           startIcon={<ReadMoreOutlined />}
//           className="document-list__upload-button"
//           iconClassName="document-list__upload-icon-button"
//         >
//           Parse Document
//         </Button>
//       </Card>
//     </div>
//   );
// };

// export default NewDocumentUpload;

import { Box, Card, Divider, Typography } from "@mui/material";
import { Button } from "common/components";
import { ReadMoreOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const NewDocumentUpload = () => {
  const navigate = useNavigate();

  return (
    <>
      <Button
        variant="text"
        onClick={() => navigate(-1)}
        style={{
          marginBottom: "24px",
          textTransform: "none",
          fontWeight: 500,
          fontSize: "1rem"
        }}
      >
        &larr; Back
      </Button>
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          pt: 7,
          pl: 6,
          background: "transparent",
          color: "#ffffff"
        }}
      >
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: "2rem",
            color: "#fff",
            mb: 0.5,
            textAlign: "left"
          }}
        >
          Upload New Document
        </Typography>

        <Card
          variant="outlined"
          sx={{
            backgroundColor: "transparent",
            borderRadius: "14px",
            border: "1px solid #e0e0e0",
            boxShadow: "0 4px 18px 0 rgba(0,0,0,0.14)",
            p: 4,
            mt: 2,
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
            gap: 2,
            width: 400
          }}
        >
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "1.09rem",
              color: "#aaaaaa",
              mb: 2,
              textAlign: "left"
            }}
          >
            Select the document to be parsed.
          </Typography>

          <Divider sx={{ width: "100%", my: 2, bgcolor: "#444" }} />
          <Button
            onClick={() => navigate(`/bulk-upload/NewDocument`)}
            variant="primary-alt"
            startIcon={<ReadMoreOutlined />}
            style={{
              alignSelf: "flex-start",
              borderRadius: 2,
              fontWeight: 500,
              boxShadow: "0 2px 8px 0 rgba(0,0,0,0.12)"
              // mt: 1
            }}
          >
            Parse Document
          </Button>
        </Card>
      </Box>
    </>
  );
};

export default NewDocumentUpload;
